<template>
  <div class="prm-new">
    <main-content>
      <template v-slot:contentArea>
        <div class="countdown-title" v-if="countDownDays >= 0">
          View registered project
          <span class="countdown-title-highlight"
            >(<span class="countdown-title-highlight-bold">{{
              countDownDays
            }}</span>
            days left until the project registration expires)</span
          >
          <el-divider />
        </div>
        <div style="margin: 20px auto; width: 90%">
          <el-steps :active="flowactive" align-center>
            <el-step
              :title="item.stepName"
              v-for="item in nodelist"
              :key="item.stepId"
              :description="
                item.todoUserName
                  ? $t('message.approver') + '(' + item.todoUserName + ')'
                  : ''
              "
            >
              <i class="iconfont icon-lingxing" slot="icon" />
            </el-step>
          </el-steps>
        </div>
        <div class="proBase-detail">
          <div class="title">
            {{ $t("page.prmDetail.contentTitle") }}
          </div>
          <div class="content">
            <el-row>
              <el-col :span="12">
                {{ $t("page.prmNew.partnerName") }}：<span class="text">{{
                  info.partnerName
                }}</span>
              </el-col>
              <el-col :span="12"
                >{{ $t("page.prmNew.country") }}：<span class="text">{{
                  info.areaName
                }}</span></el-col
              >
            </el-row>
            <el-row>
              <el-col :span="12">
                {{ $t("page.prmNew.ruijieSaleName") }}：<span class="text">{{
                  info.ruijieSaleName
                }}</span>
              </el-col>
              <el-col :span="12">
                {{ $t("page.prmNew.projectName") }}：<span class="text">{{
                  info.projectName
                }}</span>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12" v-if="false">
                {{ $t("page.prmNew.fundsInPlace") }}：<span class="text">{{
                  info.fundsInPlaceValue
                }}</span>
              </el-col>
              <el-col :span="12">
                {{ $t("page.prmNew.expectedOrderDate") }}：<span class="text">{{
                  parseTime(info.expectedOrderDate, "{y}-{m}-{d}")
                }}</span>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">{{ $t("page.prmNew.budgetFrom") }}：</el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <span class="text">{{ info.budgetFrom }}</span>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="12" v-if="false">
                {{ $t("page.prmNew.projectBudget") }}：<span class="text">{{
                  info.projectBudget
                }}</span>
                {{ info.currency }}
              </el-col>
              <el-col :span="12">
                {{ $t("page.prmNew.networkBudget") }}：<span class="text">{{
                  info.networkBudget
                }}</span>
                {{ info.currency }}
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                {{ $t("page.prmNew.projectPhase") }}：<span class="text">{{
                  info.projectPhaseValue
                }}</span>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                {{ $t("page.prmNew.projectProgressUpdate") }}：<span
                  class="text"
                  >{{ info.projectProgressUpdate }}</span
                >
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12"
                >{{ $t("page.prmNew.projectRequirements") }}：</el-col
              >
            </el-row>
            <el-row>
              <el-col :span="24">
                <span class="text">{{ info.projectRequirements }}</span>
              </el-col>
            </el-row>
            <el-row v-if="false">
              <el-col :span="12"
                >{{ $t("page.prmNew.competitorSituation") }}：</el-col
              >
            </el-row>
            <el-row>
              <el-col :span="24">
                <span class="text">{{ info.competitorSituation }}</span>
              </el-col>
            </el-row>

            <!--附件信息-->
            <el-row>
              <el-col :span="12"
                >{{ $t("page.prmNew.projectAttachmentDetail") }}：</el-col
              >
            </el-row>
            <!-- 这里放置图表 -->
            <el-row>
              <el-col :span="12" class="obvious-table-border">
                <el-table
                  class="custom-table-border"
                  :data="info.proBaseProducts"
                  :height="info.proBaseProducts.length > 10 ? 448 : null"
                  border
                  style="width: 100%"
                  :header-cell-style="{
                    background: '#e5e5e5',
                    color: '#333333',
                    textAlign: 'center',
                  }"
                  :cell-style="{ color: '#333333' }"
                >
                  <el-table-column
                    prop="productModelExcel"
                    label="Product Model In Excel"
                  />
                  <el-table-column prop="productModel" label="Product Model" />
                  <el-table-column prop="qty" label="Qty" />
                  <el-table-column prop="price" label="Price" />
                  <el-table-column prop="currency" label="currency" />
                </el-table>
              </el-col>
            </el-row>
            <el-row style="display: flex; flex-direction: column">
              <el-col
                :span="12"
                v-for="item in info.attachment"
                :key="item.areaCode"
              >
                <a
                  class="filetext"
                  href="javascript:void(0)"
                  v-if="item && item.name"
                  @click="downloadUpload(item.attachmentUrl)"
                  style="color: red"
                  >{{ item.name }}</a
                >
              </el-col>
            </el-row>
            <!--最终用户信息-->
            <el-row>
              <div class="title">
                {{ $t("page.prmDetail.endUserInfo") }}
              </div>
            </el-row>
            <el-row>
              <el-col :span="12">
                {{ $t("page.prmNew.finalCompanyName") }}：<span class="text">{{
                  info.finalCompanyName
                }}</span>
              </el-col>
              <el-col :span="12">
                {{ $t("page.prmNew.finalCompanyAddress") }}：<span
                  class="text"
                  >{{ info.finalCompanyAddress }}</span
                >
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12" v-if="false">
                {{ $t("page.prmNew.jointVisit") }}：<span class="text">
                  {{ info.jointVisitValue }}</span
                >
              </el-col>
              <el-col :span="12" v-if="start">
                {{ $t("page.prmNew.finalUserName") }}：<span class="text">{{
                  info.finalUserName
                }}</span>
              </el-col>
              <el-col :span="12" v-if="start">
                {{ $t("page.prmList.taxNumber") }}：<span class="text">{{
                  info.taxNumber
                }}</span>
              </el-col>
            </el-row>
            <el-row v-if="start">
              <el-col :span="12">
                {{ $t("page.prmNew.finalUserPosition") }}：<span class="text">{{
                  info.finalUserPosition
                }}</span>
              </el-col>
              <el-col :span="12">
                {{ $t("page.prmNew.finalUserTel") }}：<span class="text">{{
                  info.finalUserTel
                }}</span>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12" v-if="start">
                {{ $t("page.prmNew.finalUserEmail") }}：<span class="text">{{
                  info.finalUserEmail
                }}</span>
              </el-col>
              <el-col :span="12">
                {{ $t("page.prmNew.isSupportRuijie") }}：<span class="text">{{
                  info.isSupportRuijieValue
                }}</span>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                {{ $t("page.prmNew.hasCooperated") }}：<span class="text">{{
                  info.hasCooperated ? "Yes" : "No"
                }}</span>
              </el-col>
            </el-row>
            <el-row v-if="false">
              <el-col :span="12">{{ $t("page.prmNew.beforeSell") }}：</el-col>
            </el-row>
            <el-row v-if="false">
              <el-col :span="24">
                <span class="text">{{ info.beforeSell }}</span>
              </el-col>
            </el-row>
            <!--渠道信息-->
            <el-row>
              <div class="title">
                {{ $t("page.prmDetail.partnerInfo") }}
              </div>
            </el-row>
            <el-row>
              <el-col :span="12">
                {{ $t("page.prmNew.partnerEmail") }}：<span class="text">
                  {{ info.partnerEmail }}</span
                >
              </el-col>
              <el-col :span="12">
                {{ $t("page.prmNew.partnerContactName") }}：<span
                  class="text"
                  >{{ info.partnerContactName }}</span
                >
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                {{ $t("page.prmNew.partnerPhone") }}：<span class="text">
                  {{ info.partnerPhone }}</span
                >
              </el-col>
              <el-col :span="12" v-if="starts">
                {{ $t("page.prmNew.projectContractor") }}：<span class="text">{{
                  info.projectContractor
                }}</span>
              </el-col>
              <el-col :span="12" v-else>
                {{ $t("Related Tier-2 Partner") }}：<span class="text">{{
                  info.twoPartnerName
                }}</span>
              </el-col>
              <el-col :span="12" v-if="starts">
                {{ $t("page.prmNew.relatedRAP") }}：<span class="text">{{
                  info.parentCompanyName
                }}</span>
              </el-col>
            </el-row>
          </div>
        </div>
        <div class="flowLogs-list">
          <div class="title">
            {{ $t("page.prmDetail.approvalTitle") }}
          </div>
          <el-table
            :data="approvallist"
            border
            style="width: 100%; margin-top: 20px; font-size: 14px"
            tooltip-effect="dark"
          >
            <el-table-column
              align="center"
              prop="stepName"
              :label="$t('page.prmDetail.approvalNode')"
            />
            <el-table-column
              align="center"
              prop="createUserName"
              :label="$t('page.prmDetail.operator')"
            >
              <template slot-scope="scope">
                {{ scope.row.createUserName }}
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="auditStatusValue"
              :label="$t('page.prmDetail.auditStatus')"
            />
            <el-table-column
              align="center"
              prop="date"
              :label="$t('page.prmDetail.approvalDate')"
            >
              <template slot-scope="scope">
                {{ parseTime(scope.row.createTime, "{y}-{m}-{d} {h}:{i}:{s}") }}
              </template>
            </el-table-column>
            <el-table-column
              show-overflow-tooltip
              align="center"
              prop="approvalOpinion"
              :label="$t('page.prmDetail.approvalRemarks')"
            />
          </el-table>
        </div>
      </template>
    </main-content>
  </div>
</template>

<script type="es6">
import API from '../../API';
import { formate } from '../../libs/mixin';
import mainContent from '../component/mainContent';
import eventBus from '../../libs/eventBus';
import { addDate, dateDiff, parseTime } from '../../libs/util';
import APIS from '../../API/fileAxios/fileAxios';
export default {
  mixins: [formate],
  props: {
    isDetail: Boolean
  },
  data () {
    return {
      colorful: '#00CC33',
      flowactive: 0,
      nodelist: [],
      info: {},
      approvallist: [],
      allow: {},
      downloadUrl: API.axios.defaults.baseURL + '/common/attachment/',
      countDownDays: 0,
      start: false,
      starts: false,

    };
  },
  components: {
    mainContent
  },

  methods: {
    init () {
      // eslint-disable-next-line eqeqeq
      this.start = this.$route.query.start == true;
      // eslint-disable-next-line eqeqeq
      this.starts = this.$route.query.starts == true;
      // console.log(this.start);
      let id = this.$route.query.objectId;
      API.getDepartments()
        .then((res) => {
          let json = res.data;
          // eslint-disable-next-line no-undef, eqeqeq
          if (json.data.indexOf('ebgDept') != -1) {
            this.starts = true;
            this.start = false;
            // console.log(this.start, this.starts);
          }
          // eslint-disable-next-line eqeqeq, no-undef
          if (json.data.indexOf('sbgDept') != -1) {
            this.start = true;
            this.starts = false;
            // console.log(this.start, this.starts);
          }
          // eslint-disable-next-line eqeqeq
          if (json.data == []) {
            this.start = false;
            this.starts = false;
          }
        })
        .catch((e) => {
          console.log(e);
        });
      if (id) {
        if (this.isDetail) {
          API.getPrmBaseInfo(id, this.$i18n.locale).then((res) => {
            let json = res.data;
            if (json.status === '200' && json.data) {
              this.info = json.data;
              // console.log(this.info);
              if (json.data.status !== 0) {
                this.expirationCountdown();
                this.allFlow(id);
                this.curflow(id);
                this.getFlowLogs(id);
              }
              eventBus.$emit('canEdit', this.info.canEdit);
            }
          }).catch((e) => {
            console.log(e);
          });
        } else {
          API.getProBaseInfo(id, this.$i18n.locale).then((res) => {
            let json = res.data;
            if (json.status === '200' && json.data) {
              this.info = json.data;
              // console.log(this.info);
              if (json.data.status !== 0) {
                this.expirationCountdown();
                this.allFlow(id);
                this.curflow(id);
                this.getFlowLogs(id);
              }
              eventBus.$emit('canEdit', this.info.canEdit);
            }
          }).catch((e) => {
            console.log(e);
          });
        }
      }
    },
    getFlowLogs (id) {
      API.getFlowLogs(id, this.$i18n.locale).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.approvallist = json.data;
        } else {
        }
      }).catch((e) => {
        console.log(e);
      });
    },
    lastNode () {
      if (this.flowactive === this.nodelist.length - 1) {
        this.flowactive = this.nodelist.length;
      }
    },
    allFlow (id) {
      API.currentFlowtempl(id, this.$i18n.locale).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.nodelist = json.data.flowSteps;
        }
      }).catch((e) => {
        console.log(e);
      });
    },
    curflow (id) {
      API.currentFlow(id).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.flowactive = json.data.stepOrder - 1;
          this.allow = json.data;
          eventBus.$emit('currentStep', this.allow);
        }
      }).catch((e) => {
        console.log(e);
      });
    },
    expirationCountdown () {
      let projectionTime = addDate(this.info.protectionTime, 60);
      let days = dateDiff(projectionTime, parseTime(new Date().getTime(), '{y}-{m}-{d}'));
      this.countDownDays = days;
    },
    downloadUpload (id) {
      console.log(id, 8888);
      APIS.getAliOSSDownloadInfo(id).then(async (res) => {
        window.open(res.data.data.fileInfo.url);
      });
    }
  },
  mounted () {
    this.init();
  },
  watch: {
    flowactive (val) {
      this.lastNode();
    },
    nodelist () {
      this.lastNode();
    }
  }
};
</script>
<!-- rel="stylesheet/scss" -->
<style lang="scss" scoped>
@import "../../style/Approval_nodes";
.obvious-table-border {
  border: 1px solid #9a9a9a;
  padding: 0;
  box-sizing: border-box;
  overflow: hidden;
}

/* 横、纵分割线 */
::v-deep .custom-table-border th,
::v-deep .custom-table-border td {
  border-right: 1px solid #9a9a9a !important;
  border-bottom: 1px solid #9a9a9a !important;
}

/* 取消最右一列右线，防止竖线加粗 */
::v-deep .custom-table-border th:last-child,
::v-deep .custom-table-border td:last-child {
  border-right: none !important;
}
.prm-new {
  .proBase-detail {
    margin-top: 30px;

    .title {
      color: #303133;
      font-size: 16px;
      padding-left: 30px;
      background: url("../../assets/images/redsquare.png") center left no-repeat;
    }

    .content {
      margin-top: 10px;

      .el-row {
        margin: 20px 0;

        .text {
          color: #606266;
        }
      }

      .el-row:nth-last-child(2) {
        margin: 20px 0 6px 0;
      }

      .el-row:nth-last-child(1) {
        margin: 0;
      }
    }
  }

  .flowLogs-list {
    margin-top: 20px;

    .title {
      color: #303133;
      font-size: 16px;
      padding-left: 30px;
      background: url("../../assets/images/redsquare.png") center left no-repeat;
    }

    .table {
      margin-top: 20px;
    }
  }

  .countdown-title {
    color: #303133;
    font-size: 16px;
  }

  .countdown-title-highlight {
    color: #dd1d40;
  }

  .countdown-title-highlight-bold {
    font-weight: bold;
    font-size: 18px;
  }
}
</style>
